import { EMAIL_REGEX } from '../config'

// FirstName LastName <name@domain.com> -> name@domain.com
export const getCleanEmail = (value: string): string => {
  const emailRegexp = new RegExp(EMAIL_REGEX)
  const match = emailRegexp.exec(value)

  return match && match.length > 0 ? match[0] : value
}
